import styled from "styled-components";
import UnderlineButton from "../buttons/UnderlineButton";

const Wrapper = styled.div`
  z-index: 3 !important;
  height: 100%;
  width: 100%;
`;
const Center = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin: 0;
  z-index: 2 !important;
  color: white;
  height: 100%;
  width: 100%;
  top: 0;
  gap: 8px;
  background-color: black;
`;
const Text = styled.div``;

function TopBar() {
  return (
    <Wrapper>
      <Center>
        <Text>LANGTANG COLLECTION</Text>
        <UnderlineButton
          placeholder="PRE-LAUNCH"
          color="white"
          onClick={() => {
            window.location.href = "/browse";
          }}
        />
      </Center>
    </Wrapper>
  );
}

export default TopBar;
